// vendors
import {
  useMantineTheme,
  Card,
  Grid,
  UnstyledButton,
  Box,
  Text,
  Modal,
} from "@mantine/core";
import {
  IconCursorText,
  IconDialpad,
  IconSelector,
  IconCheckbox,
  IconMapPin,
  IconUpload,
  IconCircleCheck,
  IconCurrentLocation,
} from "@tabler/icons";
import "jquery-ui-dist/jquery-ui";

export default function AddFieldModal(props) {
  const theme = useMantineTheme();

  return (
    <Modal
      title="Select Field Type"
      centered
      opened={props.opened}
      onClose={() => props.onClose()}
    >
      <Grid sx={{ flexDirection: "column" }}>
        {[
          {
            label: "Text Field",
            dataType: "text",
            type: "Text",
            presentation: "TEXT_FIELD",
            icon: <IconCursorText size={16} />,
            initialValues: {
              label: "",
              translation: "",
              defaultValue: "",
              required: false,
              placeholder: "",
              regex: "",
            },
          },
          {
            label: "Number Field",
            dataType: "number",
            presentation: "NUMBER_FIELD",
            type: "number",
            icon: <IconDialpad size={16} />,
            initialValues: {
              label: "",
              translation: "",
              defaultValue: "",
              placeholder: "",
              required: false,
              min: 0,
              max: 100,
            },
            values: {},
          },
          {
            label: "Select Field",
            presentation: "SELECT", // DropDown
            dataType: "TEXT",
            type: "select",
            icon: <IconSelector size={16} />,
            initialValues: {
              label: "",
              translation: "",
              placeholder: "",
              required: false,
              defaultValue: "",
              chartType: "bar",
              answers: [{ field_value: ""}],
            },
            values: {},
          },
          {
            label: "Checkbox Field",
            dataType: "MULTICHOICE",
            type: "checkbox",
            presentation: "CHECKBOX",
            icon: <IconCheckbox size={16} />,
            initialValues: {
              label: "",
              translation: "",
              required: false,
              chartType: "bar",
              answers: [{ field_value: ""}],
            },
            values: {},
          },
          {
            label: "Radio Select Field",
            dataType: "Text",
            type: "radio",
            presentation: "RADIO",
            icon: <IconCircleCheck size={16} />,
            initialValues: {
              label: "",
              translation: "",
              placeholder: "",
              defaultValue: "",
              chartType: "bar",
              required: false,
              answers: [{ field_value: ""}],
            },
            values: {},
          },
          {
            label: "Location Field",
            dataType: "POINT_LOCATION",
            presentation: "LOCATION_SELECT",
            type: "location",
            icon: <IconMapPin size={16} />,
            initialValues: {
              label: "",
              translation: "",
              placeholder: "",
              getCoordinates: false,
              required: false,
            },
            values: {},
          },
          {
            label: "Geo Location Field",
            dataType: "POINT_LOCATION",
            presentation: "LOCATION",
            type: "location",
            icon: <IconCurrentLocation size={16} />,
            initialValues: {
              label: "",
              translation: "",
              placeholder: "",
              getCoordinates: false,
              required: false,
            },
            values: {},
          },
          {
            label: "File Upload Field",
            dataType: "file",
            type: "file",
            presentation: "FILE",
            icon: <IconUpload size={16} />,
            initialValues: {
              placeholder: "",
              label: "",
              translation: "",
              allowedFileTypes: [
                "jpg",
                "jpeg",
                "png",
                "gif",
                "pdf",
                "doc",
                "docx",
                "xls",
                "xlsx",
                "ppt",
                "pptx",
                "txt",
                "csv",
                "zip",
                "rar",
                "7z",
                "mp4",
                "mp3",
                "wav",
                "ogg",
                "webm",
                "avi",
                "mov",
                "wmv",
                "flv",
                "mkv",
                "3gp",
                "m4v",
                "m4a",
                "mpg",
                "mpeg",
                "swf",
              ],
              maxFileSize: 250,
              required: false,
            },
            values: {},
          },
          // {
          //   label: "Multi Select Field",
          //   dataType: "category",
          //   type: "multiselect",
          //   icon: <IconBoxMultiple size={16} />,
          //   values: {},
          //   disabled: true,
          // },
        ].map((field, i) => (
          <Grid.Col key={i}>
            <UnstyledButton
              sx={{ width: "100%" }}
              onClick={() => {
                typeof props.onFieldClick === typeof function () {} &&
                  props.onFieldClick(field);
              }}
              disabled={field.disabled === true ? true : false}
            >
              <Card
                withBorder
                sx={{
                  "&:hover": {
                    backgroundColor:
                      theme.colorScheme === "light"
                        ? theme.colors.gray[0]
                        : theme.colors.dark[5],
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box>{field.icon}</Box>
                  <Text size={"sm"} mx={10}>
                    {field.label}
                  </Text>
                </Box>
              </Card>
            </UnstyledButton>
          </Grid.Col>
        ))}
      </Grid>
    </Modal>
  );
}
